export default "__VITE_ASSET__BRUtTJwE__"